/** Employer entity and status types with their labels. No React or client imports, so the native app can share them. */

export type MainContractorEntityType =
  | 'limited_company'
  | 'sole_trader'
  | 'partnership'
  | 'individual'
  | 'public_body'
  | 'other';

export type EmployerStatus = 'active' | 'inactive' | 'blacklisted';

/** Lives here rather than beside the filter options in constants.ts so the two
 *  modules stay a one-way import: constants.ts reads types, never the reverse. */
export type EmployerStatusFilter = 'all' | EmployerStatus;

export const ENTITY_OPTIONS: Array<{ value: MainContractorEntityType; label: string }> = [
  { value: 'limited_company',  label: 'Limited Company' },
  { value: 'sole_trader',      label: 'Sole Trader' },
  { value: 'partnership',      label: 'Partnership' },
  { value: 'individual',       label: 'Individual / Homeowner' },
  { value: 'public_body',      label: 'Public Body' },
  { value: 'other',            label: 'Other' },
];

export const getEntityLabel = (entityType?: string) =>
  ENTITY_OPTIONS.find(o => o.value === entityType)?.label ?? 'Limited Company';

export const STATUS_OPTIONS: Array<{ value: EmployerStatus; label: string }> = [
  { value: 'active',      label: 'Active' },
  { value: 'inactive',    label: 'Inactive' },
  { value: 'blacklisted', label: 'Blacklisted' },
];
